import { whatIfInnerSelector } from '../../../WhatIfsSelector';

const amountSelector = (state, props) => (
  whatIfInnerSelector(state, props).MarketValue
);

export default amountSelector;
